import React from "react";
import { Box, Button, Typography } from "@mui/material";
import backicon from "../../../assets/backwidget.png";
import nexticon from "../../../assets/next.png";

export const NavigationFooter = ({
  activeStep,
  totalSteps,
  isNextDisabled,
  feedbackCss,
  basicLanguages,
  onBack,
  onNext,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: { xs: 2, md: 4 },
      py: 2.5,
      borderTop: "1px solid rgba(0,0,0,0.06)",
      background: "rgba(249,249,249,0.8)",
    }}
  >
    {/* Step indicator */}
    <Typography
      sx={{ fontSize: "13px", color: "#9ca3af", fontWeight: 500 }}
    >
      {activeStep + 1} / {totalSteps}
    </Typography>

    <Box sx={{ display: "flex", gap: 1.5 }}>
      {activeStep !== 0 && (
        <Button
          variant="outlined"
          onClick={onBack}
          startIcon={<img src={backicon} alt="" style={{ width: 16 }} />}
          sx={{
            borderColor: "rgba(0,0,0,0.15)",
            color: feedbackCss?.backBtnRatingTxt || "#374151",
            backgroundColor: feedbackCss?.backBtnRatingBG || "transparent",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,
            px: 2.5,
            "&:hover": {
              borderColor: "rgba(0,0,0,0.3)",
              background: "rgba(0,0,0,0.03)",
            },
          }}
        >
          {basicLanguages?.Previous}
        </Button>
      )}

      <Button
        variant="contained"
        disabled={isNextDisabled}
        onClick={onNext}
        endIcon={
          <img
            src={nexticon}
            alt=""
            style={{ width: 16, filter: "brightness(10)" }}
          />
        }
        sx={{
          backgroundColor: "#f37120",
          color: feedbackCss?.NextBtnIconTxtClr || "#fff",
          borderRadius: "10px",
          textTransform: "none",
          fontWeight: 600,
          px: 3,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 14px rgba(243,113,32,0.35)",
            filter: "brightness(1.05)",
          },
          "&:disabled": { opacity: 0.45 },
          transition: "all 0.2s",
        }}
      >
        {activeStep === 1 ? basicLanguages?.Send : basicLanguages?.Next}
      </Button>
    </Box>
  </Box>
);
